/**
 * Case-insensitive locale-aware string compare (default locale).
 * Ordering for characters such as Æ, Ø, and Å depends on the active environment locale.
 */
export const localeBaseCompare = (a: string, b: string): number =>
  a.localeCompare(b, undefined, { sensitivity: 'base' });

/**
 * Returns a new array sorted alphabetically by `name`, case-insensitive,
 * using locale-aware comparison with the runtime default locale.
 * Ordering for characters such as Æ, Ø, and Å depends on the active environment locale.
 */
export const sortByName = <T extends { name: string }>(items: readonly T[]): T[] =>
  [...items].sort((a, b) => localeBaseCompare(a.name, b.name));
